import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import logo from "./images/cNFT-logo-header.png";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import logo2 from "./images/erdstall-logo2.png";
import { Nav, Navbar } from "react-bootstrap";
import { Link, BrowserRouter, Routes, Route } from "react-router-dom";
import { FAQPage, ViewNFTPage, MintPage } from "./pages";
import "./App.css";
import { AppContext, State } from "./AppContext";
import { InfoNotice } from "./components/events/Notice";
import InfoModal, { InfoProps } from "./components/dialogs/InfoModal";
import { BrowserProvider } from "ethers";
import { Contact } from "./components";
import { ConnectMetaMask } from "./components/display";

function App() {
  const [accounts, setAccounts] = React.useState<string[]>();
  const [infoProps, setInfoProps] = React.useState<InfoProps>({
    show: false,
    toggleShow: () => {},
  });
  const [hasInfo, setShowInfo] = React.useState(false);

  React.useEffect(() => {
    document.addEventListener("InfoNotice", handleNotice);
    return () => {
      document.removeEventListener("InfoNotice", handleNotice);
    };
  });

  const handleNotice = (ev: CustomEventInit<InfoNotice>) => {
    setInfoProps({
      show: hasInfo,
      toggleShow: () => setShowInfo(false),
      title: ev.detail?.title,
      content: ev.detail?.content,
    });
    setShowInfo(true);
  };

  // Setup the web3 provider immediately, that way we can query the on-chain
  // state before/without onboarding.
  // NOTE: Changes with v6
  const provider = new BrowserProvider(window.ethereum, "sepolia");

  const ctx = {
    provider: provider,
    accounts,
    setAccounts,
  } as State;

  return (
    <>
      <BrowserRouter>
        <div className="App">
          <AppContext.Provider value={ctx}>
            <Navbar className="Navbar">
              <Navbar.Brand href="#">
                <img id={"erdstall-logo"} width="150" src={logo} alt="" />
              </Navbar.Brand>
              <Nav>
                <Link className="Link" to="/">
                  Mint cNFT
                </Link>
              </Nav>
              <Nav>
                <Link className="Link" to="/faq">
                  FAQ
                </Link>
              </Nav>
              <Nav>
                <Link
                  className="Link"
                  to="/sepolia/0x5251378f7036536325b9e2dab6d93c5924108d67/21"
                >
                  TEST
                </Link>
              </Nav>
              <Nav>
                <Link
                  className="Link"
                  to="https://erdstall.dev/"
                  target="_blank"
                >
                  Contact
                </Link>
              </Nav>
              {/* TODO: Do proper styling */}
              <div className="navbar-mm-button">
                <ConnectMetaMask />
              </div>
            </Navbar>
            <div className="Sites"></div>
            <Routes>
              <Route path="/" element={<MintPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route
                path="/sepolia/:collection/:tokenId"
                element={<ViewNFTPage />}
              />
            </Routes>
          </AppContext.Provider>
        </div>
        <div className="Footer">
          <div className="BottomLeft">
            <Contact />
          </div>
          <div className="BottomRight">
            <img src={logo2} alt="Icon" width="65" height="65"></img>
          </div>
        </div>
      </BrowserRouter>
      <InfoModal
        show={hasInfo}
        toggleShow={infoProps.toggleShow}
        title={infoProps.title}
        content={infoProps.content}
      />
    </>
  );
}

export default App;
